var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckC(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM15.1379 7.46365C15.4353 7.1753 15.4426 6.70048 15.1542 6.40311C14.8659 6.10575 14.3911 6.09844 14.0937 6.3868L8.26966 12.0344L5.90715 9.74344C5.60979 9.45509 5.13497 9.46239 4.84662 9.75976C4.55827 10.0571 4.56557 10.5319 4.86294 10.8203L7.74755 13.6175C8.03847 13.8996 8.50085 13.8996 8.79177 13.6175L15.1379 7.46365Z",
    fill: "#C4C7CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckC);
export default __webpack_public_path__ + "static/media/Check_c.38a37fcb.svg";
export { ForwardRef as ReactComponent };